export default __webpack_public_path__ + "static/media/twan-trans.0638fca5.png";